import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { serviceFactory } from '@/keycloack/factory'
import { userStoreForKeycloack } from '@/store/userStoreForKeycloack'

Vue.use(VueRouter)

class Page {
  constructor(path = null, component = null, name = null, meta = null, beforeEnter = null) {
    this.path = path
    this.name = name
    this.component = () => import(`@/pages/${component}`)
    this.beforeEnter = beforeEnter
    this.meta = meta
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/main' },
    new Page('/start', 'BeforeAuth', 'beforeAuth'),
    new Page('/main', 'index', 'index', { requiresAuth: true }),

    new Page('/schedule-list', 'ScheduleList', 'scheduleList', { requiresAuth: true }),
    new Page('/filter-schedule', 'FilterSchedule', 'filterSchedule', { requiresAuth: true }),

    new Page('/schedule', 'StudentSchedule', 'studentSchedule', { requiresAuth: true }),
    new Page('/show-exel/:idExel', 'ShowExel', 'showExelById', { requiresAuth: true }),
    new Page('/show-exel', 'ShowExel', 'showExel', { requiresAuth: true }),

    new Page('/schedule-creation', 'ScheduleCreation', 'scheduleCreation', { requiresAuth: true }),
    new Page('/schedule-editing/:idExel', 'ScheduleCreation', 'scheduleEditing', { requiresAuth: true }),

    new Page('/study-calendar', 'StudyCalendar', 'studyCalendar', { requiresAuth: true, requiresAdmin: true }),
    new Page('/discipline-original', 'DisciplineOriginal', 'disciplineOriginal', {
      requiresAuth: true,
      requiresAdmin: true
    }),
    new Page('/discipline-generated', 'DisciplineGenerated', 'disciplineGenerated', {
      requiresAuth: true,
      requiresAdmin: true
    }),
    new Page('/dictionary/subgroup', 'Subgroup', 'Subgroup', { requiresAuth: true }, (to, from, next) =>
      store.getters['user/adminRole'] ? next() : next('/')
    ),
    new Page('/assessment-grid', 'AssessmentGrid', 'AssessmentGrid', { requiresAuth: true }, (to, from, next) =>
      store.getters['user/adminRole'] ? next() : next('/')
    ),
    new Page('/dictionary/pairTime', 'PairTime', 'PairTime', { requiresAuth: true }, (to, from, next) =>
      store.getters['user/adminRole'] ? next() : next('/')
    ),
    new Page(
      '/assessment-generated/:id',
      'AssessmentGenerated',
      'AssessmentGenerated',
      { requiresAuth: true },
      (to, from, next) => {
        if (!store.getters['user/adminRole']) {
          return next('/')
        }

        next()
      }
    ),
    new Page('/assessment-list', 'AssessmentList', 'AssessmentList', { requiresAuth: true }, (to, from, next) =>
      store.getters['user/adminRole'] ? next() : next('/')
    )
  ]
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

  if (requiresAuth && !store.getters['user/isLoggedIn']) {
    const keycloakService = serviceFactory(userStoreForKeycloack)
    await keycloakService.login()
    next()
  }

  if (requiresAdmin && !store.getters['user/adminRole']) {
    return next({ name: 'index' })
  }
  next()
})

export default router
